import React, { Fragment } from 'react';

import { Typography } from '@mui/material';

import useChatDescription from '../../utils/useChatDescription';
import * as Styled from './styled';

function ChannelListHeaderDescription() {
	const description = useChatDescription();

	if (!description) return null;

	return (
		<>
			<Styled.Hr />
			<Styled.Description>
				{description.students.map((student, index) => (
					<Fragment key={index}>
						{student.userFullName && (
							<Styled.StudentWrap>
								<Typography
									variant="body2"
									sx={(theme) => ({
										color: theme.palette.mode === 'dark' ? theme.palette.text.secondary : '#999999',
									})}
								>
									{student.userLabel}:
								</Typography>
								<Typography variant="body2">{student.userFullName}</Typography>
							</Styled.StudentWrap>
						)}
						{student.value && (
							<Styled.StudentWrap>
								<Typography
									variant="body2"
									sx={(theme) => ({
										color: theme.palette.mode === 'dark' ? theme.palette.text.secondary : '#999999',
									})}
								>
									{student.label}:
								</Typography>
								<Typography variant="body2">{student.value}</Typography>
							</Styled.StudentWrap>
						)}
					</Fragment>
				))}
			</Styled.Description>
		</>
	);
}

export default ChannelListHeaderDescription;
